export default "__VITE_ASSET__216cc919__"